import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8410038a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mt-3 title is-5" }
const _hoisted_2 = { class: "table-container mb-2" }
const _hoisted_3 = { class: "table is-bordered is-striped is-hoverable" }
const _hoisted_4 = {
  rowspan: "2",
  class: "time-col"
}
const _hoisted_5 = ["colspan"]
const _hoisted_6 = { class: "slot-cell-vertical" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.weeks, (w) => {
    return (_openBlock(), _createElementBlock("div", {
      key: w.week
    }, [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t('General.Week')) + " " + _toDisplayString(w.week), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("table", _hoisted_3, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('General.Time')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.dates, (date, dateIndex) => {
                return (_openBlock(), _createElementBlock("th", {
                  key: 'day-' + date,
                  colspan: _ctx.vetsAvailability.length,
                  class: "has-text-centered day_separator"
                }, _toDisplayString(_ctx.formatDate(date)), 9, _hoisted_5))
              }), 128))
            ]),
            _createElementVNode("tr", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.dates, (date) => {
                return (_openBlock(), _createElementBlock(_Fragment, { key: date }, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vetsAvailability, (vet, index) => {
                    return (_openBlock(), _createElementBlock("th", {
                      key: date + '-' + vet.vet_id,
                      class: _normalizeClass(["has-text-centered", { 'day-separator': index === _ctx.vetsAvailability.length - 1 }])
                    }, _toDisplayString(_ctx.getInitials(vet.name)), 3))
                  }), 128))
                ], 64))
              }), 128))
            ])
          ]),
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allTimes, (time) => {
              return (_openBlock(), _createElementBlock("tr", { key: time }, [
                _createElementVNode("td", null, _toDisplayString(time), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(w.dates, (date) => {
                  return (_openBlock(), _createElementBlock(_Fragment, { key: date }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.vetsAvailability, (vet, index) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: date + '-' + vet.vet_id,
                        class: _normalizeClass({ 'day-separator': index === _ctx.vetsAvailability.length - 1 })
                      }, [
                        _createElementVNode("div", _hoisted_6, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSlotCoverage(vet, date, time), (bar) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: bar.start,
                              class: "slot-bar-vertical",
                              style: _normalizeStyle({ top: bar.start + '%', height: bar.height + '%' })
                            }, null, 4))
                          }), 128))
                        ])
                      ], 2))
                    }), 128))
                  ], 64))
                }), 128))
              ]))
            }), 128))
          ])
        ])
      ])
    ]))
  }), 128))
}